module.exports = __webpack_public_path__ + "img/time-up.fdbbee35.svg";